import React from "react";
const KYCCenters = React.lazy(() => import("./KYCCentersComponent"));

export default function KYCCentersMain() {
  return (
    <KYCCenters/>
  );
}